/* global process */
import React from 'react';
import ReactDOM from 'react-dom';
export default class ModalProvider extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.showModal = (modalContent, key) => {
            if (process.env.BROWSER) {
                return ReactDOM.createPortal(modalContent, this.portalEl, key);
            }
            ModalProvider.ssrContent = modalContent;
            return null;
        };
    }
    getChildContext() {
        return { showModal: this.showModal };
    }
    get portalEl() {
        if (process.env.BROWSER) {
            const scrollLayoutEl = document.getElementById('scroll-layout');
            const modalPortalEl = document.getElementById('modal-portal');
            if (modalPortalEl && scrollLayoutEl) {
                if (modalPortalEl.parentElement !== scrollLayoutEl) {
                    scrollLayoutEl.appendChild(modalPortalEl);
                }
            }
            return (modalPortalEl || scrollLayoutEl || document.body);
        }
        return null;
    }
    render() {
        const { children } = this.props;
        return children;
    }
}
ModalProvider.childContextTypes = {
    showModal: Function,
};
ModalProvider.ssrContent = null;
